import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-1 text-dark-muted text-sm" }
const _hoisted_2 = { class: "w-full space-x-2 flex justify-end" }

import { computed, ref, watch } from 'vue';

import { useCarModelsStore } from '@/stores/dictionary/car-models';
import { useCarBrandsStore } from '@/stores/dictionary/car-brands';
import { useModalsStore } from '@/stores/modals';
import { useI18n } from 'vue-i18n';

import { CarModelResource } from '@shared/resources/car-model';
import PageWrapper from '@components/page-wrapper/PageWrapper.vue';
import { Table, TableClientDataManager, TableComponentParams } from '@ui-kit/table';
import Button from '@ui-kit/controls/button/Button.vue';
import ModalConfirmation from '@components/modals/ModalConfirmation.vue';
import ModalManageCarModel from './modals/ModalManageCarModel.vue';
import { SingleSelect, useSelectClientDataManager } from '@ui-kit/inputs/select';
import { CarBrandResource } from '@shared/resources/car-brand';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageCarModels',
  setup(__props) {

const carModelsStore = useCarModelsStore();
const carBrandsStore = useCarBrandsStore();
const modalsStore = useModalsStore();
const { t } = useI18n();

const tableManager = new TableClientDataManager({
  providedData: computed(() => carModelsStore.data),
  loading: computed(() => carModelsStore.isLoad),
  searchBy: ['name', 'car_brand.name', 'car_brand.country'],
});
const tableParams = computed<TableComponentParams<CarModelResource>>(() => {
  return {
    columns: [
      {
        name: 'name',
        data: 'name',
        title: t('fields.name'),
        responsiveOrder: 1,
        sortable: true,
      },
      {
        name: 'car_brand.name',
        data: 'car_brand.name',
        title: t('fields.car_brand'),
        sortable: true,
      },
      {
        name: 'car_brand.country',
        data: 'car_brand.country',
        title: t('fields.country'),
        sortable: true,
      },
      {
        name: 'actions',
        title: '',
        width: 200,
        responsiveOrder: 2,
      },
    ]
  }
});

const selectedCarBrand = ref<CarBrandResource>();
watch(selectedCarBrand, (value) => {
  tableManager.setFilters(value ? {
    'car_brand.id': String(value.id),
  } : {});
});
const brandsSelectManager = useSelectClientDataManager({
  data: computed(() => carBrandsStore.data),
  selected: selectedCarBrand,
  hideSelected: true,
  searchBy: ['name', 'country'],
});

function manageCarModel(model?: CarModelResource) {
  modalsStore.addModal({
    component: ModalManageCarModel,
    props: {
      data: model,
    },
  });
}
function removeCarModel(model: CarModelResource) {
  modalsStore.addModal({
    component: ModalConfirmation,
    props: {
      title: t('pages.car-models.remove-label'),
      danger: true,
      confirmText: t('common.actions.delete'),
      confirm: () => {
        return carModelsStore.remove(model.id);
      }
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(PageWrapper, {
    title: _ctx.$t('navigation.car_models')
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Table), {
        "data-manager": _unref(tableManager),
        params: _unref(tableParams)
      }, {
        "header-left": _withCtx(() => [
          _createVNode(_unref(SingleSelect), {
            class: "w-64",
            "data-manager": _unref(brandsSelectManager),
            modelValue: selectedCarBrand.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCarBrand).value = $event)),
            "select-option-text": _ctx.$t('pages.car-models.select-brand')
          }, {
            option: _withCtx(({option}) => [
              _createTextVNode(_toDisplayString(option.name) + " ", 1),
              _createElementVNode("span", _hoisted_1, "(" + _toDisplayString(option.country) + ")", 1)
            ]),
            _: 1
          }, 8, ["data-manager", "modelValue", "select-option-text"])
        ]),
        "header-right": _withCtx(() => [
          _createVNode(Button, {
            size: "xl",
            "button-type": "outline",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (manageCarModel()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "plus",
                class: "mr-2"
              }),
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.create_new')), 1)
            ]),
            _: 1
          })
        ]),
        "cell-actions": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Button, {
              size: "sm",
              onClick: ($event: any) => (manageCarModel(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, {
                  icon: "pen",
                  class: "mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('common.actions.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(Button, {
              size: "sm",
              color: "danger",
              onClick: ($event: any) => (removeCarModel(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, { icon: "trash" })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["data-manager", "params"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})